<template>
  <transition-group name="listAnswerSurface">
    <slot></slot>
  </transition-group>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "TransitionGroupFromTop"
});
</script>

<style>
.listAnswerSurface-enter-active {
  transition: all 0.3s ease;
}
.listAnswerSurface-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.listAnswerSurface-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.listAnswerSurface-leave-active {
  transition: all 0.25s ease;
  position: absolute;
}
.listAnswerSurface-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.listAnswerSurface-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.listAnswerSurface-move {
  transition: transform 0.25s ease;
}
</style>
